"use strict";

exports.__esModule = true;
exports.AlertScreenToolbar = AlertScreenToolbar;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _System = require("../../../System");
var _Calendar = require("../../Calendar");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector/MultiDeviceSelector");
var _Core = require("../../Core");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _Device = require("../../Device");
var _Time = require("../../Time");
var _Auth = require("../../Auth");
var _featureFlags = require("../../../featureFlags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Left = _styledComponents["default"].div.withConfig({
  displayName: "AlertScreenToolbar__Left",
  componentId: "sc-1kyun0r-0"
})(["display:flex;flex-direction:row;> span{padding:0 0.2rem;}"]);
var Right = (0, _styledComponents["default"])(_core.ControlGroup).withConfig({
  displayName: "AlertScreenToolbar__Right",
  componentId: "sc-1kyun0r-1"
})(["flex:0.5;display:flex;flex-direction:row;flex-flow:row-reverse;> span{padding:0 0 0 0.2rem;}"]);
var AlertToolbar = (0, _styledComponents["default"])(_Core.Toolbar).withConfig({
  displayName: "AlertScreenToolbar__AlertToolbar",
  componentId: "sc-1kyun0r-2"
})(["display:flex;"]);
function AlertScreenToolbar(props) {
  var style = props.style,
    devices = props.devices,
    _props$externalButton = props.externalButtonGroupEnabled,
    externalButtonGroupEnabled = _props$externalButton === void 0 ? true : _props$externalButton,
    _props$multipleDays = props.multipleDays,
    multipleDays = _props$multipleDays === void 0 ? true : _props$multipleDays,
    AdditionalRightComponents = props.AdditionalRightComponents,
    AdditionalLeftComponents = props.AdditionalLeftComponents;
  var urlFilter = _react["default"].useContext(_URLFilter.URLFilterContext);
  var reportingPeriod = _react["default"].useContext(_ReportingPeriod.ReportingPeriodContext);
  var deviceTags = _react["default"].useContext(_Device.DeviceTagListContext);
  var _React$useContext = _react["default"].useContext(_Calendar.CalendarContext),
    calendar = _React$useContext.calendar;
  var time = _react["default"].useContext(_Time.TimeContext);
  var currentPlantWorkdayId = (0, _Calendar.getDate)(time.currentWorkday.interval.endMillis);
  var filters = urlFilter.filters,
    setFilter = urlFilter.setFilter;
  var start = (0, _Calendar.startOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.startMillis).id);
  var end = (0, _Calendar.endOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.endMillis - 1).id);
  return /*#__PURE__*/_react["default"].createElement(AlertToolbar, {
    style: style,
    "data-testid": "AlertScreenToolbar.container"
  }, /*#__PURE__*/_react["default"].createElement(Left, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
    style: {
      maxWidth: 200
    },
    devices: devices,
    tags: deviceTags,
    selectAllByDefault: true,
    selected: filters.device,
    onSelect: function onSelect(devices) {
      return setFilter("device", devices.map(function (device) {
        return device.uuid;
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Time.WorkdaySelector, {
    disabled: false,
    multiple: multipleDays,
    maxDate: currentPlantWorkdayId,
    selected: [start, end],
    onSelect: function onSelect(selected) {
      if (selected.length === 0) {
        return;
      }

      // This can result in the days incrementing/decrementing from what the user selected
      var interval = calendar.getIntervalForWorkdays((0, _Calendar.toDateString)(selected));
      var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
      return setFilter("period", parts.join("/"));
    }
  }), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, AdditionalLeftComponents))), /*#__PURE__*/_react["default"].createElement(Right, null, AdditionalRightComponents), externalButtonGroupEnabled ? /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "CREATE_ALERT",
    featureFlag: _featureFlags.ENABLE_ALERTS_CREATION
  }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    "data-testid": "AlertScreenToolbar.AlertsCreationButton",
    to: (0, _System.getScreenURL)("AlertsCreation"),
    icon: _icons.IconNames.PLUS,
    intent: _core.Intent.PRIMARY,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AlertScreenToolbar.buttons.AlertsCreation.label",
      defaultMessage: "Create Alert"
    })
  })), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_ALERT",
    featureFlag: "ENABLE_ALERTS_ANALYSIS"
  }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    "data-testid": "AlertScreenToolbar.AlertsAnalysisButton",
    to: (0, _System.getScreenURL)("AlertsAnalysis"),
    icon: _icons.IconNames.TIMELINE_BAR_CHART,
    minimal: true,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AlertScreenToolbar.buttons.AlertsAnalysis.label",
      defaultMessage: "Alert Analysis"
    })
  })), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "CONFIGURE_TICKETING"
  }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    "data-testid": "AlertScreenToolbar.AlertWatcherRulesButton",
    to: (0, _System.getScreenURL)("AlertWatcherRuleList"),
    icon: _icons.IconNames.ISSUE,
    minimal: true,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "AlertScreenToolbar.buttons.ManageAlertWatcherRules.label",
      defaultMessage: "Alert Watcher Rules"
    })
  })))) : null);
}